import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Menu } from "antd";
import { FiEdit, FiPlus, FiSearch, FiShield, FiTrash2 } from "react-icons/fi";

import http from "./../../services/http";
import { confirm, modalSuccess } from "../../services/notifications";
import { actions, hasPermission } from "../../services/security";
import { TableContextProvider } from "./../../store/table-context";

import Card from "./../../components/ui/card";
import Header from "../../components/ui/header";
import Filters from "./../../components/ui/filters";
import Table from "../../components/ui/table";

const PerfilesListPage = () => {
  let navigate = useNavigate();

  const title = "Perfiles";
  const icon = <FiShield />;
  const breadcrumb = [{ title: "Perfiles", url: "/perfiles" }];

  const [isFilter, setIsFilter] = useState(false);
  const [filters, setFilters] = useState([
    {
      type: "input",
      label: "Nombre",
      name: "nombre",
    },
  ]);

  const columns = [{ title: "Nombre", property: "nombre", sortable: true }];

  const menu = (item) => (
    <Menu>
      {!hasPermission(actions.PerfilesEditar) && (
        <Menu.Item
          key="1"
          icon={<FiSearch />}
          onClick={() => onClickEdit(item)}
        >
          Ver
        </Menu.Item>
      )}
      {hasPermission(actions.PerfilesEditar) && (
        <Menu.Item key="1" icon={<FiEdit />} onClick={() => onClickEdit(item)}>
          Editar
        </Menu.Item>
      )}
      {hasPermission(actions.PerfilesEliminar) && (
        <Menu.Item
          key="2"
          icon={<FiTrash2 />}
          onClick={() => onClickDelete(item)}
        >
          Eliminar
        </Menu.Item>
      )}
    </Menu>
  );

  const onClickAdd = () => {
    navigate("/perfiles/nuevo");
  };

  const onClickEdit = (item) => {
    navigate(`/perfiles/${item.id}`);
  };

  const onClickDelete = async (item) => {
    const confirmed = await confirm(
      "Eliminar perfil",
      `¿Esta seguro que desea eliminar el perfil ${item.nombre}?`
    );

    if (!confirmed) {
      return;
    }

    const response = await http.delete(`perfiles/${item.id}`);
    if (response) {
      await modalSuccess(
        "Perfil eliminado",
        "El perfil fue eliminado exitosamente"
      );
      navigate(0);
    }
  };

  const buttons = [
    {
      title: "Agregar Perfil",
      text: <FiPlus />,
      type: "primary",
      onClick: onClickAdd,
      visible: hasPermission(actions.PerfilesCrear),
    },
  ];

  return (
    <TableContextProvider>
      <Card>
        <Header
          title={title}
          icon={icon}
          breadcrumb={breadcrumb}
          showFilters
          buttons={buttons}
          isFilter={isFilter}
        />
        <Filters fields={filters} />
        <Table
          id="table-perfiles"
          columns={columns}
          menu={menu}
          url="/perfiles"
          orderBy="nombre"
          orderDirection="ascending"
          setIsFilter={setIsFilter}
        />
      </Card>
    </TableContextProvider>
  );
};

export default PerfilesListPage;
